(function () {
  var MQ = window.matchMedia('(min-width: 750px)');

  function initDeck(root) {
    var rail = root.querySelector('[data-noirsy-day-rail]');
    if (!rail || rail.dataset.noirsyDeckBound === '1') return;
    rail.dataset.noirsyDeckBound = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-noirsy-day-dot]'));
    var prevBtn = root.querySelector('[data-noirsy-day-prev]');
    var nextBtn = root.querySelector('[data-noirsy-day-next]');
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dy = 0;
    var deciding = false;
    var lockedAxis = null;
    var activePointerId = null;

    function cards() {
      return Array.prototype.slice.call(rail.querySelectorAll('[data-noirsy-day-card]'));
    }

    function syncStack() {
      var list = cards();
      list.forEach(function (card, i) {
        card.classList.remove('is-top', 'is-leaving', 'is-dragging');
        card.style.removeProperty('--drag-x');
        card.style.removeProperty('--drag-y');
        card.style.removeProperty('--drag-r');
        card.style.zIndex = String(list.length - i);
        card.dataset.stack = String(Math.min(i, 3));
        card.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        if (i === 0) card.classList.add('is-top');
      });

      if (!list.length) return;
      var id = list[0].getAttribute('data-card-id');
      dots.forEach(function (dot) {
        var on = dot.getAttribute('data-noirsy-day-dot') === id;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function topCard() {
      return rail.querySelector('[data-noirsy-day-card].is-top') || cards()[0] || null;
    }

    function setDrag(card, x, y) {
      var rot = x * 0.05;
      card.style.setProperty('--drag-x', x + 'px');
      card.style.setProperty('--drag-y', y + 'px');
      card.style.setProperty('--drag-r', rot + 'deg');
    }

    function clearDrag(card) {
      if (!card) return;
      card.style.removeProperty('--drag-x');
      card.style.removeProperty('--drag-y');
      card.style.removeProperty('--drag-r');
      card.classList.remove('is-dragging');
    }

    function recycleInstant(card) {
      if (!card) return;
      card.classList.remove('is-leaving', 'is-leaving--left', 'is-leaving--right', 'is-dragging', 'is-top');
      clearDrag(card);
      rail.appendChild(card);
      syncStack();
    }

    function recycle(card, dir) {
      if (!card || deciding) return;
      deciding = true;
      card.classList.add('is-leaving');
      card.classList.add(dir < 0 ? 'is-leaving--left' : 'is-leaving--right');

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        card.classList.remove('is-leaving', 'is-leaving--left', 'is-leaving--right', 'is-dragging', 'is-top');
        clearDrag(card);
        rail.appendChild(card);
        syncStack();
        deciding = false;
      }

      card.addEventListener('transitionend', finish, { once: true });
      window.setTimeout(finish, 420);
    }

    function goNext() {
      if (MQ.matches || deciding) return;
      var card = topCard();
      if (card) recycle(card, 1);
    }

    function goPrev() {
      if (MQ.matches || deciding) return;
      var list = cards();
      if (list.length < 2) return;
      deciding = true;
      var last = list[list.length - 1];
      var first = list[0];
      last.classList.remove('is-leaving', 'is-leaving--left', 'is-leaving--right', 'is-dragging');
      clearDrag(last);
      rail.insertBefore(last, first);
      syncStack();
      // brief settle so side-stack transition reads
      window.setTimeout(function () {
        deciding = false;
      }, 220);
    }

    function onPointerDown(e) {
      if (MQ.matches || deciding) return;
      var card = topCard();
      if (!card || !card.contains(e.target)) return;
      if (e.target.closest('a, button')) return;

      dragging = true;
      lockedAxis = null;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
      dy = 0;
      card.classList.add('is-dragging');
      try {
        card.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!dragging || MQ.matches || deciding) return;
      if (activePointerId != null && e.pointerId !== activePointerId) return;
      var card = topCard();
      if (!card) return;

      dx = e.clientX - startX;
      dy = e.clientY - startY;

      if (!lockedAxis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (lockedAxis === 'y') {
        // Allow page scroll — cancel horizontal deck drag
        dragging = false;
        clearDrag(card);
        try {
          card.releasePointerCapture(e.pointerId);
        } catch (err) {}
        return;
      }

      e.preventDefault();
      setDrag(card, dx, dy * 0.15);
    }

    function onPointerUp(e) {
      if (!dragging || MQ.matches) return;
      if (activePointerId != null && e.pointerId !== activePointerId) return;
      dragging = false;
      activePointerId = null;
      var card = topCard();
      if (!card) return;

      var threshold = Math.min(120, rail.clientWidth * 0.28);
      if (lockedAxis === 'x' && Math.abs(dx) > threshold) {
        recycle(card, dx < 0 ? -1 : 1);
      } else {
        card.classList.remove('is-dragging');
        clearDrag(card);
      }
      lockedAxis = null;
      dx = 0;
      dy = 0;
    }

    rail.addEventListener('pointerdown', onPointerDown);
    rail.addEventListener('pointermove', onPointerMove, { passive: false });
    rail.addEventListener('pointerup', onPointerUp);
    rail.addEventListener('pointercancel', onPointerUp);

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (prevBtn) prevBtn.addEventListener('click', goPrev);

    // Keyboard: left/right for a11y
    root.addEventListener('keydown', function (e) {
      if (MQ.matches || deciding) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      if (e.key === 'ArrowLeft') goPrev();
      else goNext();
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (MQ.matches || deciding) return;
        var targetId = dot.getAttribute('data-noirsy-day-dot');
        var guard = 0;
        while (guard < 12) {
          var top = topCard();
          if (!top) break;
          if (top.getAttribute('data-card-id') === targetId) break;
          recycleInstant(top);
          guard += 1;
        }
      });
    });

    function onMq() {
      clearDrag(topCard());
      dragging = false;
      deciding = false;
      syncStack();
    }
    if (MQ.addEventListener) MQ.addEventListener('change', onMq);
    else MQ.addListener(onMq);

    syncStack();
  }

  function boot() {
    document.querySelectorAll('[data-noirsy-day-edit]').forEach(initDeck);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-noirsy-day-edit]')
      : null;
    if (root) {
      var rail = root.querySelector('[data-noirsy-day-rail]');
      if (rail) delete rail.dataset.noirsyDeckBound;
      initDeck(root);
    }
  });
})();
